import { useState } from "react"

export const SetUpState = () => {
    const [searchInput, setSearchInput] = useState('');
    const [infiniteState, setInfiniteState] = useState({limit:20, offset:0, infiniteLoad:false, dataType:'string'});
    const [listLoader, setListLoader] = useState({isloading:true})
    const [snackBarLoader, setSnackBarLoader] = useState({snackbar:false, msg:'', type:''})

    const [branchData, setBranchData] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [branchSearchList, setBranchSearchList] = useState([]);
    
    const [categoryData, setCategoryData] = useState([]);
    const [categoryList, setCategoryList] = useState([])
    const [categorySearchList, setCategorySearchList] = useState([])
    const [categoryFilter, setCategoryFilter] = useState(0)
    
    const [productData, setProductData] = useState([]);
    const [productList, setProductList] = useState([])
    const [productSearchList, setProductSearchList] = useState([])
    
    const [branchProductData, setBranchProductData] = useState([]);
    const [branchProductList, setBranchProductList] = useState([])
    const [branchProductSearchList, setBranchProductSearchList] = useState([])

    const [branchUserData, setBranchUserData] = useState([]);
    const [branchUserList, setBranchUserList] = useState([])
    const [branchUserSearchList, setBranchUserSearchList] = useState([])

    const [warehouseData, setWarehouseData] = useState([]);
    const [warehouseList, setWarehouseList] = useState([]);
    const [warehouseSearchList, setWarehouseSearchList] = useState([]);

    const [warehouseUserData, setWarehouseUserData] = useState([]);
    const [warehouseUserList, setWarehouseUserList] = useState([]);
    const [warehouseUserSearchList, setWarehouseUserSearchList] = useState([]);

    const [supplierData, setSupplierData] = useState([]);
    const [supplierList, setSupplierList] = useState([]);
    const [supplierSearchList, setSupplierSearchList] = useState([]);

    const [warehouseProductData, setWarehouseProductData] = useState([]);
    const [warehouseProductList, setWarehouseProductList] = useState([]);
    const [warehouseProductSearchList, setWarehouseProductSearchList] = useState([]);

    const [uomData, setUomData] = useState([]);
    const [toolUser, setToolUser] = useState([]);
    const [industry, setIndustry] = useState([]);
    
    return {
        searchInput: {data: searchInput, set: setSearchInput},
        infiniteState: {data: infiniteState, set: setInfiniteState},
        listLoader: {data: listLoader, set: setListLoader},
        snackBarLoader: {data: snackBarLoader, set: setSnackBarLoader},
        branchData: {data: branchData, set: setBranchData},
        branchList: {data: branchList, set: setBranchList},
        branchSearchList: {data: branchSearchList, set: setBranchSearchList},
        categoryData: {data: categoryData, set: setCategoryData},
        categoryList: {data: categoryList, set: setCategoryList},
        categorySearchList: {data: categorySearchList, set: setCategorySearchList},
        categoryFilter: {data: categoryFilter, set: setCategoryFilter},
        productData: {data: productData, set: setProductData},
        productList: {data: productList, set: setProductList},
        productSearchList: {data: productSearchList, set: setProductSearchList},
        branchProductData: {data: branchProductData, set: setBranchProductData},
        branchProductList: {data: branchProductList, set: setBranchProductList},
        branchProductSearchList: {data: branchProductSearchList, set: setBranchProductSearchList},
        branchUserData: {data: branchUserData, set: setBranchUserData},
        branchUserList: {data: branchUserList, set: setBranchUserList},
        branchUserSearchList: {data: branchUserSearchList, set: setBranchUserSearchList},
        
        warehouseData: {data: warehouseData, set: setWarehouseData},
        warehouseList: {data: warehouseList, set: setWarehouseList},
        warehouseSearchList: {data: warehouseSearchList, set: setWarehouseSearchList},

        warehouseUserData: {data: warehouseUserData, set: setWarehouseUserData},
        warehouseUserList: {data: warehouseUserList, set: setWarehouseUserList},
        warehouseUserSearchList: {data: warehouseUserSearchList, set: setWarehouseUserSearchList},

        supplierData: {data: supplierData, set: setSupplierData},
        supplierList: {data: supplierList, set: setSupplierList},
        supplierSearchList: {data: supplierSearchList, set: setSupplierSearchList},

        warehouseProductData: {data: warehouseProductData, set: setWarehouseProductData},
        warehouseProductList: {data: warehouseProductList, set: setWarehouseProductList},
        warehouseProductSearchList: {data: warehouseProductSearchList, set: setWarehouseProductSearchList},

        uomData: {data: uomData, set: setUomData},
        toolUser: {data: toolUser, set: setToolUser},
        industry: {data: industry, set: setIndustry},
    }
}